import { useContext, useEffect, useState } from "react";
import "./Winner.css";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { useLocation, useNavigate } from "react-router-dom";
import { routeNames } from "../../constants/routeNames";
import glass from "../../assets/images/glass.png";
import { Button } from "react-bootstrap";
import whatsappIcon from "../../assets/images/icons/whatsapp.svg";

export const Winner = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [prize, setPrize] = useState({});
  const [uniqueCode, setUniqueCode] = useState({});

  useEffect(() => {
    if (location?.state?.redirected && location?.state?.prize) {
      setTitle("You’re a Winner!");
      setPrize(location?.state?.prize);
      setUniqueCode(location?.state?.uniqueCode);
      setLoading(false);
    } else {
      setLoading(true);
      navigate(routeNames.LANDING);
    }
  }, [location?.state]);

  const sendMessageToWhatsApp = () => {
    const message = encodeURIComponent(
      `Your mate has shared a free Coca-Cola Zero Sugar with you.

Present this voucher to a member of staff in any participating Greene King outlet to redeem.

Your voucher code: ${uniqueCode?.code}

Enjoy!

For full terms see ${window.location.origin}/terms`
    );
    window.open(`https://wa.me/?text=${message}`, "_blank");
  };

  return (
    <div className="text-center ">
      <h2
        className="simple-content-title"
        style={{
          marginBottom: "32px",
        }}
      >
        Congrats, you've won {prize?.title}{" "}
      </h2>

      {prize?.description && (
        <p className="winner-description">{prize?.description}</p>
      )}

      <img src={prize?.image} className="prize-image mx-auto" />

      {uniqueCode && (
        <>
          <p className="winner-description">
            Here's a free Coca-Cola for your mate on us
          </p>

          <div className="code-box">{uniqueCode?.code}</div>

          <img src={glass} className="prize-image mx-auto" />

          <div className="text-center">
            <Button
              onClick={sendMessageToWhatsApp}
              className="wp-button d-flex mx-auto "
              type="submit"
            >
              <img src={whatsappIcon} alt="whatsapp-icon" />
              <span
                className="text-center"
                style={{ width: "calc(100% - 14px)", textAlign: "center" }}
              >
                Share with a mate
              </span>
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
